module.exports = __webpack_public_path__ + "AllenDigital-GooglePlayStore.png";